import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

export default function NewMovies() {
  const newMovies = movies.filter((m) => m.new);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-green-500">
              <i className="ri-flashlight-line text-white text-sm"></i>
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950">
                最新上线
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                新鲜出炉，追新片快人一步
              </p>
            </div>
          </div>
          <a
            href="/category/kehuan"
            onClick={(e) => {
              e.preventDefault();
              window.REACT_APP_NAVIGATE("/category/kehuan");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
        {newMovies.length === 0 && (
          <div className="text-center py-16">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200">
              <i className="ri-inbox-line text-2xl text-foreground-400"></i>
            </div>
            <p className="mt-4 text-foreground-500 text-sm">
              暂无最新电影，敬请期待
            </p>
          </div>
        )}
      </div>
    </section>
  );
}